/**
 * Legal pages (Terms, Privacy) — "On this page" scrollspy.
 *
 * The TOC links and section IDs are server-rendered by page-legal.php; this
 * just highlights the link for the section currently in view via
 * IntersectionObserver, matching the handoff (rootMargin '-80px 0px -75%').
 */
export function initLegalToc() {
	const toc = document.querySelector('.lg-toc');
	if (!toc) return;

	const links = new Map();
	toc.querySelectorAll('a[href^="#"]').forEach((a) => {
		links.set(a.getAttribute('href').slice(1), a);
	});
	if (!links.size) return;

	const sections = Array.from(links.keys())
		.map((id) => document.getElementById(id))
		.filter(Boolean);
	if (!sections.length) return;

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					links.forEach((a) => a.classList.remove('active'));
					const link = links.get(entry.target.id);
					if (link) link.classList.add('active');
				}
			});
		},
		{ rootMargin: '-80px 0px -75% 0px', threshold: 0 }
	);
	sections.forEach((s) => observer.observe(s));
}
